import { TableServiceRequestCell } from '../../Table'
import { getEmailLinkedRequests } from '../Email.utils'

function EmailTableRowServiceRequest({ item, ...cellProps }) {
  return (
    <TableServiceRequestCell
      {...cellProps}
      items={getEmailLinkedRequests(item)}
    />
  )
}

export default EmailTableRowServiceRequest
